import { Component } from '@theme/component';
import { createFavouritesStore, FAVOURITES_KEY } from '@theme/ts-favourites-store';
import { familyKey, uniqueFamilies, chooseLinkedVariant } from '@theme/ts-product-families';
const config = JSON.parse(document.getElementById('ts-product-tools-config')?.textContent || '{}');
let storage;
try { storage = window.localStorage; } catch { storage = { getItem() { throw new Error('Storage unavailable'); }, setItem() { throw new Error('Storage unavailable'); } }; }
const favourites = createFavouritesStore(storage);
window.addEventListener('storage', event => { if (event.key === FAVOURITES_KEY || event.key === null) favourites.refresh(); });
const announce = message => { const status = document.getElementById('ts-favourites-live'); if (status) status.textContent = message; };
const cardFor = element => element.closest('[data-ts-product-card]');
function saveFavouriteVariant(root, variantId) {
  const key = familyKey(root.dataset.productId, root.dataset.tsHandle);
  const saved = favourites.get().filter(item => familyKey(item.id, item.handle) === key);
  if (!saved.length) return;
  favourites.replaceProduct(saved[0].id, { id: root.dataset.productId, handle: root.dataset.tsHandle, variantId });
  for (const item of saved.slice(1)) if (item.id !== root.dataset.productId) favourites.remove(item.id);
}
const imageIssues = new Set();
function recordImageIssue(root, colour, reason) {
  const key = `${root.dataset.productId}:${colour.id}:${reason}`;
  if (imageIssues.has(key)) return;
  imageIssues.add(key);
  const issue = { productId: root.dataset.productId, handle: root.dataset.tsHandle, variantId: colour.id, reason };
  try { const issues = JSON.parse(sessionStorage.getItem('theo-sally:variant-image-review:v1') || '[]'); if (Array.isArray(issues) && !issues.some(item => item.productId === issue.productId && item.variantId === issue.variantId && item.reason === reason)) sessionStorage.setItem('theo-sally:variant-image-review:v1', JSON.stringify([...issues, issue].slice(-200))); } catch {}
  root.dispatchEvent(new CustomEvent('ts:variant-image-missing', { bubbles: true, detail: issue }));
}


class FavouriteToggle extends Component {
  connectedCallback() { super.connectedCallback(); this.unsubscribe?.(); this.unsubscribe = favourites.subscribe(() => this.update()); }
  disconnectedCallback() { super.disconnectedCallback(); this.unsubscribe?.(); }
  updatedCallback() { super.updatedCallback(); this.update(); }
  update() {
    const saved = favourites.get().some(item => familyKey(item.id, item.handle) === familyKey(this.dataset.productId, this.dataset.handle));
    const button = this.querySelector('button');
    button?.setAttribute('aria-pressed', String(saved));
    button?.setAttribute('aria-label', saved ? this.dataset.removeLabel : this.dataset.addLabel);
  }
  handleControlKeyDown(event) {
    event.stopPropagation();
    if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); this.toggle(event); }
  }
  toggle(event) {
    event.preventDefault(); event.stopPropagation();
    const root = cardFor(this);
    const saved = favourites.get().some(item => familyKey(item.id, item.handle) === familyKey(this.dataset.productId, this.dataset.handle));
    let variantId = root?.dataset.tsSelectedVariant || this.dataset.variantId;
    if (this.dataset.productPage === 'true' && /^\d+$/.test(this.dataset.productId)) {
      const currentInput = [...document.querySelectorAll(`#MainContent product-form-component[data-product-id="${this.dataset.productId}"] input[name="id"]`)]
        .find(input => !input.closest('quick-add-component, quick-add-dialog, dialog, product-card') && /^\d+$/.test(input.value));
      if (currentInput) variantId = currentInput.value;
    }
    let persisted = true;
    if (saved) {
      for (const item of favourites.get().filter(item => familyKey(item.id, item.handle) === familyKey(this.dataset.productId, this.dataset.handle))) persisted = favourites.remove(item.id) && persisted;
    } else persisted = favourites.toggle({ id: this.dataset.productId, handle: this.dataset.handle, variantId });
    announce(persisted ? (saved ? config.removed : config.saved) : config.storageError);
    if (!this.isConnected) { const page = document.querySelector('ts-favourites-page'); const next = page?.querySelector('.ts-favourites__grid button') || page?.querySelector('.ts-favourites__empty a'); next?.focus({ preventScroll: true }); }
  }
}
class FavouritesLink extends Component {
  connectedCallback() { super.connectedCallback(); this.unsubscribe?.(); this.unsubscribe = favourites.subscribe(items => this.update(items)); }
  disconnectedCallback() { super.disconnectedCallback(); this.unsubscribe?.(); }
  updatedCallback() { super.updatedCallback(); this.update(favourites.get()); }
  update(items) {
    items = uniqueFamilies(items);
    const link = this.querySelector('a');
    if (!link || !this.refs.count) return;
    this.refs.count.textContent = String(items.length);
    this.refs.count.hidden = items.length === 0;
    link.setAttribute('aria-label', items.length ? link.dataset.countLabel.replace('[count]', String(items.length)) : link.dataset.label);
  }
}
class CardColours extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller?.abort(); this.controller = new AbortController();
    try { this.colours = JSON.parse(this.querySelector('[data-ts-colour-data]').textContent); } catch { this.colours = []; }
    for (const colour of this.colours) if (colour.style === 'transparent') recordImageIssue(cardFor(this), colour, 'unknown-colour-swatch');
    const selectedId = cardFor(this)?.dataset.tsSelectedVariant || this.dataset.initialVariant;
    const initial = this.colours.find(colour => colour.id === selectedId);
    if (initial) { this.apply(initial, false); this.showImage(cardFor(this), initial, true); }
    this.refs.popover?.addEventListener('toggle', event => this.querySelector('.ts-card-colours__more')?.setAttribute('aria-expanded', String(event.newState === 'open')), { signal: this.controller.signal });
    this.refs.popover?.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.closeMore(); } }, { signal: this.controller.signal });
  }
  disconnectedCallback() { super.disconnectedCallback(); this.controller?.abort(); }
  updatedCallback() { super.updatedCallback(); this.connectedCallback(); }
  handleControlKeyDown(event) {
    event.stopPropagation();
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (event.target.closest('.ts-card-colours__more')) this.showMore(event); else this.selectColour(event);
    } else if (event.key === 'Escape' && this.refs.popover && (this.refs.popover.matches(':popover-open') || this.refs.popover.classList.contains('ts-card-colours__popover--open'))) { event.preventDefault(); this.closeMore(); }
  }
  selectColour(event) {
    event.preventDefault(); event.stopPropagation();
    const button = event.target.closest('[data-ts-colour]');
    const colour = this.colours[Number(button?.dataset.tsColour)];
    if (!colour) return;
    this.apply(colour, true);
    if (button.closest('.ts-card-colours__popover')) this.closeMore();
    if (this.refs.status) this.refs.status.textContent = this.dataset.colourStatus.replace('[colour]', colour.name) + (!colour.image ? '. ' + this.dataset.imageMissingLabel : '') + (!colour.available ? '. ' + config.soldOut : '');
  }
  apply(colour, changeImage) {
    const root = cardFor(this);
    if (!root) return;
    root.dataset.tsSelectedVariant = colour.id;
    root.dataset.tsPrice = String(colour.price);
    root.dataset.tsAvailable = String(colour.available);
    root.dataset.tsSelectedOptions = JSON.stringify(colour.options || []);
    const visibleChoices = [...this.querySelectorAll('.ts-card-colours__choice')];
    const selectedIndex = this.colours.findIndex(item => item.id === colour.id);
    if (selectedIndex >= 0 && !visibleChoices.some(button => Number(button.dataset.tsColour) === selectedIndex)) {
      const button = visibleChoices[0];
      if (button) { button.dataset.tsColour = String(selectedIndex); button.setAttribute('aria-label', this.dataset.chooseLabel.replace('[colour]', colour.name)); button.title = colour.name; button.querySelector('.ts-card-colours__dot').style.background = colour.style; }
    }
    for (const button of this.querySelectorAll('[data-ts-colour]')) button.setAttribute('aria-pressed', String(this.colours[Number(button.dataset.tsColour)]?.id === colour.id));
    for (const link of root.querySelectorAll('a[href]')) {
      const url = new URL(link.href, location.href);
      if (url.pathname.includes('/products/') && !link.matches('[data-ts-colour], [data-ts-configuration]') && !root.contains(link.closest('quick-add-component, quick-add, dialog'))) { url.searchParams.set('variant', colour.id); link.href = url.href; }
    }
    const price = [...root.querySelectorAll('product-price [ref="priceContainer"], [data-ts-card-price]')].find(element => !root.contains(element.closest('quick-add-component, quick-add, dialog')));
    if (price) { const markup = document.createElement('template'); markup.innerHTML = colour.priceHtml; price.innerHTML = markup.content.querySelector('[ref="priceContainer"]')?.innerHTML || colour.priceHtml; }
    const catalog = root.closest('[data-preview-card]');
    if (catalog) { catalog.dataset.price = String(colour.price); catalog.dataset.available = String(colour.available); }
    for (const input of root.querySelectorAll('input[name="id"]')) {
      if (!input.closest('dialog')) input.value = colour.id;
    }
    const quickAdd = root.querySelector('quick-add-component, quick-add');
    if (quickAdd) quickAdd.hidden = !colour.available;
    root.dataset.tsSoldOut = String(!colour.available);
    const gallery = root.querySelector('.card-gallery, .resource-card__media');
    if (gallery) { let badge = gallery.querySelector('.ts-card-availability'); if (!badge) { badge = document.createElement('span'); badge.className = 'ts-card-availability'; badge.textContent = config.soldOut; gallery.append(badge); } badge.hidden = colour.available; }
    if (changeImage || !colour.image) this.showImage(root, colour);
    if (changeImage) {
      saveFavouriteVariant(root, colour.id);
      root.dispatchEvent(new CustomEvent('ts:card-variant-changed', { bubbles: true }));
    }
  }
  showImage(root, colour, initial = false) {
    const gallery = root.querySelector('.card-gallery, .resource-card__media');
    if (!gallery) return;
    const initialLoading = initial && gallery.querySelector('img')?.getAttribute('loading') === 'lazy' ? 'lazy' : 'eager';
    gallery.classList.add('ts-card-media-selected');
    let layer = gallery.querySelector('.ts-card-selected-media');
    if (!layer) { layer = document.createElement('div'); layer.className = 'ts-card-selected-media'; gallery.append(layer); }
    layer.replaceChildren();
    if (colour.image) {
      const image = document.createElement('img'); image.loading = initialLoading; image.src = colour.image; image.alt = colour.alt; image.width = 700; image.height = 700; image.decoding = 'async';
      image.addEventListener('error', () => { layer.textContent = this.dataset.imageMissingLabel; layer.classList.add('ts-card-selected-media--missing'); recordImageIssue(root, colour, 'image-load-failed'); }, { once: true, signal: this.controller.signal });
      layer.classList.remove('ts-card-selected-media--missing'); layer.append(image);
    } else { layer.textContent = this.dataset.imageMissingLabel; layer.classList.add('ts-card-selected-media--missing'); recordImageIssue(root, colour, 'no-verified-variant-image'); }
    // The selected verified image stays visible during hover and quick-add hydration.
    root.setAttribute('data-product-transition', 'false');
    root.closest('product-card-link')?.setAttribute('data-product-transition', 'false');
  }
  showMore(event) {
    event.preventDefault(); event.stopPropagation();
    const panel = this.refs.popover;
    if (!panel) return;
    const anchor = event.target.closest('button');
    const rect = anchor.getBoundingClientRect();
    panel.style.insetInlineStart = Math.max(8, Math.min(rect.left, window.innerWidth - 228)) + 'px';
    panel.style.insetBlockStart = Math.max(8, Math.min(rect.bottom + 6, window.innerHeight - 300)) + 'px';
    if (panel.showPopover) { if (panel.matches(':popover-open')) panel.hidePopover(); else panel.showPopover(); }
    else { panel.classList.toggle('ts-card-colours__popover--open'); anchor.setAttribute('aria-expanded', String(panel.classList.contains('ts-card-colours__popover--open'))); }
    panel.querySelector('button, [role="button"]')?.focus();
  }
  closeMore() {
    const panel = this.refs.popover;
    if (panel?.hidePopover && panel.matches(':popover-open')) panel.hidePopover();
    panel?.classList.remove('ts-card-colours__popover--open');
    const button = this.querySelector('.ts-card-colours__more'); button?.setAttribute('aria-expanded', 'false'); button?.focus();
  }
}
const linkedStyles = new Set();
class LinkedCardColours extends Component {
  connectedCallback() {
    super.connectedCallback(); this.controller?.abort(); this.controller = new AbortController();
    this.refs.popover?.addEventListener('toggle', event => this.querySelector('.ts-card-colours__more')?.setAttribute('aria-expanded', String(event.newState === 'open')), { signal: this.controller.signal });
    this.refs.popover?.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.closeMore(); } }, { signal: this.controller.signal });
  }
  disconnectedCallback() { super.disconnectedCallback(); this.controller?.abort(); }
  updatedCallback() { super.updatedCallback(); this.connectedCallback(); }
  handleControlKeyDown(event) { CardColours.prototype.handleControlKeyDown.call(this, event); }
  showMore(event) { CardColours.prototype.showMore.call(this, event); }
  closeMore() { CardColours.prototype.closeMore.call(this); }
  selectColour(event) {
    event.preventDefault(); event.stopPropagation();
    return this.selectProduct(event.target.closest('[data-ts-colour], [data-ts-configuration]'), event.type === 'keydown' || event.detail === 0);
  }
  selectConfiguration(event) {
    event.stopPropagation();
    return this.selectProduct(event.target.selectedOptions?.[0], true);
  }
  async selectProduct(choice, restoreFocus = false) {
    const root = cardFor(this);
    if (!choice || !root || this.busy || (choice.getAttribute('aria-pressed') === 'true' || choice.dataset.productId === root.dataset.productId)) return;
    this.busy = true; this.setAttribute('aria-busy', 'true');
    const signal = this.controller.signal;
    root.dispatchEvent(new CustomEvent('ts:card-variant-will-change', { bubbles: true }));
    try {
      const url = new URL(choice.href || choice.value, location.origin);
      const productResponse = await fetch(url.pathname + '.js', { signal });
      if (!productResponse.ok) throw new Error('unavailable');
      const product = await productResponse.json();
      if (String(product.id) !== choice.dataset.productId) throw new Error('wrong-product');
      const options = JSON.parse(root.dataset.tsSelectedOptions || '[]');
      const names = JSON.parse(root.dataset.tsOptionNames || '[]');
      const variant = chooseLinkedVariant(product, options, names);
      if (!variant) throw new Error('unavailable-choice');
      url.searchParams.set('section_id', root.matches('.resource-card') ? 'ts-linked-resource-card' : 'ts-favourite-card'); url.searchParams.set('variant', String(variant.id));
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error('unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const card = doc.querySelector(`[data-ts-product-card][data-product-id="${product.id}"]`);
      if (!card || card.dataset.tsSelectedVariant !== String(variant.id)) throw new Error('wrong-variant');
      if (!this.isConnected || signal.aborted) return;
      for (const style of doc.querySelectorAll('style[data-section-stylesheet], link[rel="stylesheet"]')) {
        const key = style.getAttribute('href') || style.textContent;
        if (!linkedStyles.has(key)) { linkedStyles.add(key); document.head.append(style.cloneNode(true)); }
      }
      card.id = root.id; card.className = root.className;
      card.setAttribute('style', root.getAttribute('style') || '');
      card.dataset.productTransition = 'false';
      card.dataset.tsPrice = String(variant.price);
      card.dataset.tsAvailable = String(variant.available);
      if (!variant.available) {
        card.dataset.tsSoldOut = 'true';
        const quickAdd = card.querySelector('quick-add-component'); if (quickAdd) quickAdd.hidden = true;
        let badge = card.querySelector('.ts-card-availability');
        if (!badge) { badge = document.createElement('span'); badge.className = 'ts-card-availability'; (card.querySelector('.card-gallery, .resource-card__media') || card).append(badge); }
        badge.textContent = config.soldOut;
      }
      const holder = root.closest('[data-preview-card]');
      if (holder) { holder.dataset.price = String(variant.price); holder.dataset.title = product.title; holder.dataset.available = String(variant.available); }
      const oldId = root.dataset.productId;
      const saved = favourites.get().some(item => familyKey(item.id, item.handle) === familyKey(oldId, root.dataset.tsHandle));
      const favouriteHolder = root.closest('[data-favourite-id]');
      if (saved && favouriteHolder) {
        const duplicate = [...favouriteHolder.parentElement.children].find(item => item !== favouriteHolder && item.dataset.favouriteId === String(product.id));
        duplicate?.remove(); favouriteHolder.dataset.favouriteId = String(product.id);
      }
      const enclosingLink = root.closest('product-card-link, product-component');
      if (enclosingLink) { enclosingLink.setAttribute('data-product-transition', 'false'); enclosingLink.setAttribute('data-product-id', String(product.id)); enclosingLink.removeAttribute('view-event-payload'); for (const link of enclosingLink.querySelectorAll(':scope > a')) link.href = url.pathname + '?variant=' + variant.id; }
      root.replaceWith(card);
      if (saved) saveFavouriteVariant(card, String(variant.id));
      if (restoreFocus) card.querySelector(`[data-ts-colour="${CSS.escape(product.handle)}"], [data-ts-configuration-select], a[data-ts-configuration="${CSS.escape(product.handle)}"]`)?.focus({ preventScroll: true });
      card.dispatchEvent(new CustomEvent('ts:card-variant-changed', { bubbles: true }));
      announce(this.dataset.colourStatus.replace('[colour]', choice.dataset.colourName) + (!variant.available ? '. ' + config.soldOut : ''));
    } catch (error) {
      if (error.name !== 'AbortError' && this.isConnected) {
        const select = this.querySelector('[data-ts-configuration-select]');
        const initial = [...(select?.options || [])].find(option => option.dataset.productId === root.dataset.productId);
        if (select && initial) select.value = initial.value;
        const message = error.message === 'unavailable-choice' ? (choice.dataset.unavailableChoice || this.dataset.errorLabel) : this.dataset.errorLabel;
        if (this.refs.status) { this.refs.status.textContent = message; this.refs.status.classList.remove('visually-hidden'); this.refs.status.classList.add('ts-card-colours__status'); }
        announce(message);
      }
    } finally { this.busy = false; this.removeAttribute('aria-busy'); }
  }
}
class FavouritesPage extends Component {
  connectedCallback() {
    super.connectedCallback(); this.controller?.abort(); this.controller = new AbortController();
    for (const pending of this.refs.grid?.querySelectorAll(':scope > [aria-busy]') || []) pending.remove();
    this.unsubscribe?.(); this.unsubscribe = favourites.subscribe(items => this.renderItems(items));
  }
  disconnectedCallback() { super.disconnectedCallback(); this.unsubscribe?.(); this.controller?.abort(); this.queue = []; }
  updatedCallback() { super.updatedCallback(); this.renderItems(favourites.get()); }
  renderItems(items) {
    items = uniqueFamilies(items);
    const grid = this.refs.grid;
    if (!grid) return;
    this.refs.empty.hidden = items.length > 0;
    grid.hidden = items.length === 0;
    const ids = new Set(items.map(item => item.id));
    for (const child of [...grid.children]) if (!ids.has(child.dataset.favouriteId)) child.remove();
    for (const item of items) {
      if ([...grid.children].some(child => child.dataset.favouriteId === item.id)) continue;
      const holder = document.createElement('li'); holder.dataset.favouriteId = item.id; holder.className = 'ts-favourites__item';
      holder.setAttribute('aria-busy', 'true');
      const skeleton = document.createElement('div'); skeleton.className = 'ts-favourites__skeleton'; skeleton.setAttribute('aria-label', this.dataset.loadingLabel); holder.append(skeleton); grid.append(holder);
      this.queueCard(item, holder);
    }
  }
  queueCard(item, holder) {
    this.queue ||= []; this.activeLoads ||= 0;
    this.queue.push({ item, holder }); this.drainQueue();
  }
  drainQueue() {
    while (this.activeLoads < 3 && this.queue?.length && !this.controller.signal.aborted) {
      const { item, holder } = this.queue.shift();
      if (!holder.isConnected) continue;
      this.activeLoads++;
      this.loadCard(item, holder).finally(() => { this.activeLoads--; this.drainQueue(); });
    }
  }
  async loadCard(item, holder) {
    const url = new URL(`${(config.root || '/').replace(/\/?$/, '/')}products/${encodeURIComponent(item.handle)}`, location.origin);
    url.searchParams.set('section_id', 'ts-favourite-card'); if (item.variantId) url.searchParams.set('variant', item.variantId);
    try {
      const response = await fetch(url, { signal: this.controller.signal });
      if (!response.ok) throw new Error(response.status === 404 ? 'unavailable' : 'network');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const card = doc.querySelector(`product-card[data-product-id="${item.id}"]`);
      if (!card) throw new Error('unavailable');
      if (!holder.isConnected || !favourites.has(item.id)) return;
      // Keep the section's subset stylesheet when extracting the common product card.
      for (const style of doc.querySelectorAll('style[data-section-stylesheet], link[rel="stylesheet"]')) {
        const key = style.getAttribute('href') || style.textContent;
        if (!this.loadedStyles) this.loadedStyles = new Set();
        if (!this.loadedStyles.has(key)) { this.loadedStyles.add(key); this.append(style.cloneNode(true)); }
      }
      holder.replaceChildren(card);
    } catch (error) {
      if (error.name === 'AbortError' || !holder.isConnected) return;
      holder.replaceChildren();
      const text = document.createElement('p'); text.textContent = error.message === 'unavailable' ? this.dataset.unavailableLabel : this.dataset.errorLabel; holder.append(text);
      if (error.message !== 'unavailable') { const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'button-secondary'; retry.textContent = this.dataset.retryLabel; retry.addEventListener('click', () => this.loadCard(item, holder), { signal: this.controller.signal }); holder.append(retry); }
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'button-secondary'; remove.textContent = this.dataset.removeLabel; remove.addEventListener('click', () => favourites.remove(item.id), { signal: this.controller.signal }); holder.append(remove);
    } finally { holder.removeAttribute('aria-busy'); }
  }
}
for (const [name, component] of [['ts-favourite-toggle', FavouriteToggle], ['ts-favourites-link', FavouritesLink], ['ts-card-colours', CardColours], ['ts-linked-card-colours', LinkedCardColours], ['ts-favourites-page', FavouritesPage]]) if (!customElements.get(name)) customElements.define(name, component);


